import { render } from "./NonKbm.vue?vue&type=template&id=d38eb4aa"
import script from "./NonKbm.vue?vue&type=script&lang=js"
export * from "./NonKbm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__